import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'SystemManagementApi';
const listGroups = async ({}) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Group/list', {}, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const listUsers = async ({ GroupName, UserPoolId, Limit, NextToken }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Group/listUsers', { GroupName, UserPoolId, Limit, NextToken }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
/**
 * **Group DAO**
 */
export const GroupDAO = {
    listGroups,
    listUsers,
};
